import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { HorizontalHomecard } from '@spotahome/ui-library';
import { withLocales } from '@spotahome/soyuz/client';
import { localesShape } from '@spotahome/soyuz/shapes';

import '@spotahome/ui-library/lib/components/Homecard/HorizontalHomecard/components/HomecardWrapper.css';
import '@spotahome/ui-library/lib/components/Homecard/HorizontalHomecard/components/HomecardImage.css';
import '@spotahome/ui-library/lib/components/Homecard/HorizontalHomecard/components/HomecardContent.css';
import '@spotahome/ui-library/lib/components/Homecard/common/HomecardLabel.css';
import '@spotahome/ui-library/lib/components/Homecard/common/VerifiedLabel.css';
import '@spotahome/ui-library/lib/components/Homecard/common/Price.css';
import '@spotahome/ui-library/lib/components/Favourite.css';
import '@spotahome/ui-library/lib/components/Rating.css';

import AdsQueryApiService from '../../../LEGACY/javascripts/cornucopia/ads/ads-query-api-service';
import { getUrlWithMovingDates } from '../../utils/homecards';

import HomecardMapPlaceholder from './HomecardMapPlaceholder';
import './HomecardMap.scss';

const fetchHomecard = async (id, locale) => {
  const { data } = await AdsQueryApiService.getHomecardsFromIds([id], locale);
  return (data && data.homecards && data.homecards[0]) || undefined;
};

const HomecardMap = ({
  id,
  locales: { current: locale },
  filters: { 'move-in': moveIn, 'move-out': moveOut },
  ...rest
}) => {
  const [loading, setLoading] = useState(false);
  const [homecard, setHomecard] = useState();
  useEffect(() => {
    setLoading(true);
    fetchHomecard(id, locale)
      .then(result => {
        setHomecard(result);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id, locale]);
  if (loading || !homecard) {
    return <HomecardMapPlaceholder />;
  }
  return (
    <HorizontalHomecard
      {...rest}
      className="homecard-map"
      availableFrom={homecard.firstAvailableDate}
      favourite={homecard.isFavorite}
      type={homecard.type}
      handleFavourite={() => {}}
      image={homecard.mainPhotoUrl}
      link={getUrlWithMovingDates(homecard.url, moveIn, moveOut)}
      price={{
        type: homecard.monthlyPrice.type,
        amount: homecard.monthlyPrice.minimumPrice,
        currencyCode: homecard.currencyIsoCode
      }}
      title={homecard.title}
    />
  );
};

HomecardMap.propTypes = {
  id: PropTypes.number.isRequired,
  locales: PropTypes.shape(localesShape).isRequired,
  filters: PropTypes.shape({
    moveIn: PropTypes.string,
    moveOut: PropTypes.string
  })
};
HomecardMap.defaultProps = {
  filters: {
    moveIn: '',
    moveOut: ''
  }
};

export default withLocales()(HomecardMap);
